type Truthy<T> = T extends false | '' | 0 | null | undefined ? never : T;

/**
 * Returns the truthiness of the provided value.
 *
 * This function operates identically to `Boolean`, but is also a type predicate
 * which makes it useful for e.g. filtering an array.
 *
 * @param value the value to check
 * @returns whether the value is truthy
 */
export const isTruthy = <T>(value: T): value is Truthy<T> => Boolean(value);
